import"./Radio.css.ts.vanilla.css";var r="_1rltzt41",t="_1rltzt40";export{r as radioLabel,t as srOnly};
